import React, { useCallback, useEffect, useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, CheckIcon } from 'lucide-react';
const BUYERS = [{
  name: 'Lucía M.',
  city: 'Buenos Aires'
}, {
  name: 'Sebastián G.',
  city: 'Córdoba'
}, {
  name: 'Agustina R.',
  city: 'Rosario'
}, {
  name: 'Matías L.',
  city: 'Mendoza'
}, {
  name: 'Camila F.',
  city: 'La Plata'
}, {
  name: 'Tomás B.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta V.',
  city: 'Tucumán'
}, {
  name: 'Facundo H.',
  city: 'Santa Fe'
}, {
  name: 'Romina D.',
  city: 'Salta'
}, {
  name: 'Ezequiel M.',
  city: 'San Juan'
}];
export const SocialProofPopup = memo(function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showPopup = useCallback(() => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % BUYERS.length);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    // Initial show after 5 seconds
    const initialTimeout = setTimeout(showPopup, 5000);
    // Recurring show every 20 seconds
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showPopup]);
  const data = BUYERS[currentIndex];
  return <AnimatePresence data-id="element-122">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-xs w-full" data-id="element-123">
          <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-4 border-l-4 border-green-500" data-id="element-124">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-125">
              <ShoppingBagIcon className="w-5 h-5 text-green-600" data-id="element-126" />
            </div>
            <div data-id="element-127">
              <p className="text-sm font-medium text-gray-900" data-id="element-128">
                <span className="font-bold" data-id="element-129">{data.name}</span> de {data.city}
              </p>
              <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-130">
                acaba de adquirir el kit
                <CheckIcon className="w-3 h-3 text-green-500" data-id="element-131" />
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
});